module.exports = __webpack_public_path__ + "assets/img/7.6ce485eb.png";